import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import STLViewer from "../../STLViewer";
import { getAnalyzerResults } from "../../services/part/partService";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import CommentIcon from '@mui/icons-material/Comment';

import AnalysisPanel from "../AnalyzePanel/AnalysisPanel";
import ResultsInformationCard from "../ResultsInformationCard/ResultsInformationCard";
import Loader from "../../utils/loader/Loader";
import "../InputRequirement/inputRequirement.scss";
import "./viewResults.scss";
import { RootState } from "../../redux/store/store";

const ViewResults = (props) => {
  const userData = useSelector((state: RootState) => state.login);
  const { userName } = userData;
  const isAdmin = props.isAdmin || false; // Get from props
  
  const [modelName, setModelName] = useState("");
  const [analyzeDetails, setAnalyzeDetails] = useState();
  const [showLoader, setShowLoader] = useState(true);
  const [violationInfo, setViolationInfo] = useState({
    header: "",
    violation: "",
  });
  const [resultStep, setResultStep] = useState(0); // 0: Part, 1: Print
  const [commentMessage, setCommentMessage] = useState("");
  const [comments, setComments] = useState<Array<{
    id: number;
    sender: string;
    text: string;
    time: string;
    isAdmin: boolean;
  }>>([]);

  useEffect(() => {
    getResults();
  }, []);

  const getResults = async () => {
    const spiltFileExt = props.modelName.split(".");
    const checkExtLength = spiltFileExt[spiltFileExt.length - 1].length;
    const toRemoveLength = checkExtLength === 4 ? 5 : 4;
    const partName = props.modelName.substring(
      0,
      props.modelName.length - toRemoveLength
    );

    await getAnalyzerResults(props.partId, partName + "-results.json").then(
      (response) => {
        if (response) {
          const file = response?.tests?.size?.file
            ? response?.tests?.size?.file
            : response?.part.file;
          setModelName(file);
          setAnalyzeDetails(response);
          setViolationInfo({ header: Object.keys(response?.tests)[0], violation: response?.tests?.size?.violation || "" });
          setShowLoader(false);
        }
      }
    );
  };

  const loadSelectedPart = (file, name, violation) => {
    if (file) {
      setModelName(file);
      setViolationInfo({ header: name, violation: violation });
    }
  };

  const handleResultNext = () => {
    if (resultStep === 0) {
      setResultStep(1);
    } else if (resultStep === 1) {
      // Navigate to next page if needed
      props.handleNext();
    }
  };

  const handleEditInputRequirements = () => {
    // Navigate back to input requirements
    // This will be handled by parent component
    if (props.onEditInputRequirements) {
      props.onEditInputRequirements();
    }
  };

  const handleSendComment = () => {
    if (commentMessage.trim()) {
      const currentTime = new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      const newComment = {
        id: comments.length + 1,
        sender: isAdmin ? "Admin" : "You",
        text: commentMessage,
        time: currentTime,
        isAdmin: isAdmin
      };
      setComments([...comments, newComment]);
      setCommentMessage("");
    }
  };

  if (showLoader) {
    return <Loader visible={showLoader} />;
  }

  return (
    <div>
      <section className="plates page review-page">
        <section className="plate view">
          <div className="left-menu w-25 part-specification">
            {/* Header */}
            <div className="input-requirements-header-section">
              <h2 className="input-requirements-header">Summary of Results</h2>
              <p className="part-name-display">Part Name: <span style={{color:'#ff6900', fontSize:'17px'}}>{props.partName}</span></p>
            </div>
            
            {/* Horizontal Tab Navigation */}
            <div className="specification-tabs-horizontal">
              <div 
                className={`spec-tab-horizontal ${resultStep === 0 ? 'active' : ''}`}
                onClick={() => setResultStep(0)}
              >
                <span className="tab-label">Part</span>
              </div>
              <div 
                className={`spec-tab-horizontal ${resultStep === 1 ? 'active' : ''}`}
                onClick={() => setResultStep(1)}
              >
                <span className="tab-label">Print</span>
              </div>
            </div>

            {/* Scrollable Content Area */}
            <div className="specification-content-scrollable">
              {resultStep === 0 && (
                <div className="results-content">
                  <AnalysisPanel
                    handleNext={() => {}}
                    analyzeResult={analyzeDetails}
                    handleInfoClick={loadSelectedPart}
                    hideButton={true}
                  />
                </div>
              )}
              {resultStep === 1 && (
                <div className="results-content">
                  <h3 className="results-title">Print Analysis Results</h3>                 
                  <div className="results-card">
                    <div className="result-item">
                      <span className="result-label">Estimated Print Time:</span> <span>3.5 hours</span>
                    </div>                   
                    <div className="result-item">
                      <span className="result-label">Estimate Paste Consumption:</span> <span>250 mL</span>
                    </div>
                    {/* <div className="result-item">
                      <span className="result-label">Support Required:</span> <span>Minimal</span>
                    </div> */}
                  </div>
                </div>
              )}
            </div>

            {/* Fixed Bottom Buttons */}
            <div className="fixed-bottom-button">
              <div className="button-group">
                <Button
                  className="btn btn-edit-input w-100"
                  onClick={handleEditInputRequirements}
                >
                  Edit Input Requirements
                </Button>
                <Button
                  className="btn btn-primary w-100"
                  variant="primary"
                  onClick={handleResultNext}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
          <div className="right-view prevew-controls view-results w-75">
            {modelName && (
              <STLViewer
                showPartDetails={true}
                modelName={modelName}
                partId={props.partId}
                sourceType={"derived"}
                isLoaded={() => {}}
                violationDetails={violationInfo}
              />
            )}

            {modelName && (
              <ResultsInformationCard
                partName={props.partName}
                modelName={props.modelName}
                analyzeResult={analyzeDetails}
              />
            )}          
          </div>
            {/* Comments Section */}
            <div className="comments-section">
              <div className="comments-header">
                <h3>Comments</h3>
                <div className="comments-header-actions">
                  <CommentIcon />
                </div>
              </div>
              
              <div className="comments-body">
                {comments.length === 0 ? (
                  <div className="comments-helper">
                    <CommentIcon className="helper-icon" />
                    <p className="helper-text-main">
                      Share your thoughts, ask questions, or provide feedback about this part analysis.
                    </p>
                    
                  </div>
                ) : (
                  comments.map((comment) => (
                    <div key={comment.id} className={`comment-message ${comment.isAdmin ? 'admin-message' : 'user-message'}`}>
                      {comment.isAdmin && (
                        <div className="message-avatar">
                          <CommentIcon />
                        </div>
                      )}
                      <div className="message-content">
                        <div className="message-sender">{comment.sender}</div>
                        <div className="message-text">{comment.text}</div>
                        <div className="message-time">{comment.time}</div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              <div className="comments-footer">
                <Form.Control
                  as="textarea"
                  rows={1}
                  placeholder="Type a comment..."
                  value={commentMessage}
                  onChange={(e) => setCommentMessage(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleSendComment();
                    }
                  }}
                  className="comment-input"
                  onInput={(e) => {
                    const target = e.target as HTMLTextAreaElement;
                    target.style.height = '38px';
                    if (target.scrollHeight > 38) {
                      target.style.height = Math.min(target.scrollHeight, 150) + 'px';
                    }
                  }}
                />
                <Button 
                  variant="primary" 
                  className="send-button"
                  onClick={handleSendComment}
                >
                  Send
                </Button>
              </div>
            </div>
        </section>
      </section>
    </div>
  );
};

export default ViewResults;
